module.exports = __webpack_public_path__ + "img/co2.3f1badb8.svg";